<template>
  <div id="regionCarousel">
    <div class="row">
      <div class="col-12">
        <h2 id="regionTitle">{{ $t("common.keywords.regions") }}</h2>
      </div>
    </div>
    <div class="container">
      <div class="row mt-3">
        <div class="col-12">
          <swiper-container
            ref="mySwiper"
            v-if="regions"
            slides-per-view="3"
            space-between="0"
            loop="true"
            pagination="true"
            navigation="false"
            centeredSlides="true"
            autoplay='{
              "delay": 3000,
              "disableOnInteraction": true
            }'
            breakpoints='{
              "0": {
                "slidesPerView": 1,
                "spaceBetween": 0
              },
              "576": {
                "slidesPerView": 2,
                "spaceBetween": 0
              },
              "992": {
                "slidesPerView": 3,
                "spaceBetween": 0
              }
            }'
            class="mySwiper"
          >
            <swiper-slide
              class="col-lg-4 col-sm-6 col-xs-12 col-12 no-row-padding mx-auto pb-4"
              v-for="region in regions"
              :key="region.id"
            >
              <ImageCard
                :title="region.localizedName | localized"
                :link="region.url"
                :image="resolveImage(region.image, 'thumb')"
              />
            </swiper-slide>
          </swiper-container>
          <Spinner v-else></Spinner>
          <button @click="prevSlide" class="custom-prev-button">
            <i class="fas fa-chevron-left" style="color: #7C94A8;"></i>
          </button>
          <button @click="nextSlide" class="custom-next-button">
            <i class="fas fa-chevron-right" style="color: #7C94A8;"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from "@/components/common/Spinner";
import ImageCard from "@/components/level1/ImageCard";

export default {
  name: "RegionCarousel",
  components: {
    Spinner,
    ImageCard,
  },
  computed: {
    regions() {
      return this.$store.getters.getRegions;
    },
  },
  methods: {
    prevSlide() {
      this.$refs.mySwiper.swiper.slidePrev();
    },
    nextSlide() {
      this.$refs.mySwiper.swiper.slideNext();
    },
  },
};
</script>

<style lang="scss" scoped>
#regionTitle {
    color: $text-color;
    text-align: center;
    @media (max-width: 640px) {
        margin-bottom: 0;
    }
}

.swiper {
  width: 100%;
  height: auto;
}

.swiper-slide {
  display: flex;
  justify-content: center;
}

.container, .swiper {
  overflow: visible !important;
}

.swiper-pagination-bullet {
  background: $primary-color;
}

/* Custom navigation buttons */
.custom-prev-button,
.custom-next-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: transparent;
  border: none;
  padding: 10px;
  cursor: pointer;
  z-index: 10;
  font-size: 24px;
  line-height: 1;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.custom-prev-button {
  left: -30px; /* Adjust as needed */
}

.custom-next-button {
  right: -30px; /* Adjust as needed */
}

/* Hide buttons on mobile */
@media (max-width: 992px) {
  .custom-prev-button,
  .custom-next-button {
    display: none;
  }
}
</style>
